module.exports = __webpack_public_path__ + "img/20181230.4617d0a5.png";